/**
 * Factory for creating EventService instances based on platform
 */

import ConfigurationManager from '../../infra/configuration/ConfigurationManager';
import NativeEventService from './nativeEventService/NativeEventService';
import WebEventService from './webEventService/WebEventService';
import IEventService from './IEventService';
import { EventServiceInputType } from '../../infra/startup/types';

/**
 * Parameters for creating EventService strategies
 */
export interface IEventServiceFactoryParams {
  isNative: boolean;
}

/**
 * Factory Pattern to encapsulate EventService creation logic
 */
export class EventServiceFactory {
  /**
   * Creates the appropriate EventService based on the platform
   */
  static createService(params: IEventServiceFactoryParams): IEventService {
    const { isNative } = params;

    if (isNative) {
      const eventServiceProps = ConfigurationManager.getProps('event');

      return new NativeEventService(eventServiceProps);
    } else {
      return new WebEventService();
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['NativeEventService', 'WebEventService'];
  }
}
